import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";

import MachineLearning from "./MachineLearning";

const MachineLearningsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Machine Learning | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Machine Learning" pagesub="Machine Learning" />
                       <MachineLearning></MachineLearning>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default MachineLearningsinglepage;
